import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { AccountUnderlyingModel } from 'src/app/model/account-underlying.model';
import { UnitPriceModel } from '../../../../model/unit-price.model';

export const RequestAction = createAction('[Unit-prices view] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Unit-prices  view] set data', props<{ payload: UnitPriceModel }>());

